import { API, authClient } from "../index";

export const postSupplier = async (supplier, accessToken) => {
	return authClient(accessToken).post(`${API}/suppliers`, supplier);
};

export const getSuppliers = (accessToken) => {
	return authClient(accessToken).get(`${API}/suppliers`);
};

export const getSupplierById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/suppliers/${id}`);
};

export const updateSupplier = async (id, supplier, accessToken) => {
	return authClient(accessToken).put(`${API}/suppliers/${id}`, supplier);
};

export const changeStatusSupplier = async (id, active, accessToken) => {
	return authClient(accessToken).put(
		`${API}/suppliers/${id}/status?active=${active}`
	);
};

export const deleteSupplier = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/suppliers/${id}`);
};
